/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Style from './EmprestimoGarantiaCarroOQueE.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import RedButton from '@/components/atoms/RedButton';

function EmprestimoGarantiaCarroOQueE() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);
  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="emp-garantia-carro-o-que-e">
        <div className="santander-symbol" />
        <ContainerHome24>
          <h2 className="o-que-e-titulo">O que é o Empréstimo com Garantia de Veículo?</h2>
          <p className="o-que-e-subtitulo">
            No <b>Empréstimo com Garantia</b>, o veículo continua sendo seu, mas é colocado como
            garantia em seu empréstimo.
            <br /> Assim, você possui maiores chances de aprovação e uma taxa vantajosa comparada a
            outros produtos.
          </p>
          <div className="o-que-e-cards">
            <div className="o-que-e-card-sinal">
              <div className="o-que-e-card">
                <img
                  src="assets/emprestimo-garantia-carro/ic_car.svg"
                  alt="ícone carro"
                  width="40"
                  height="40"
                />
                <p className="o-que-e-card-texto">
                  Carro quitado
                  <br /> como garantia
                </p>
              </div>
              <img
                className="o-que-e-sinal"
                src="assets/emprestimo-garantia-carro/ic_add.svg"
                alt="sinal de mais"
                width="40"
                height="40"
              />
            </div>
            <div className="o-que-e-card-sinal">
              <div className="o-que-e-card">
                <img
                  src="assets/emprestimo-garantia-carro/ic_document.svg"
                  alt="ícone contratação"
                  width="40"
                  height="40"
                />
                <p className="o-que-e-card-texto">
                  Contratação
                  <br /> 100% online
                </p>
              </div>
              <img
                className="o-que-e-sinal"
                src="assets/emprestimo-garantia-carro/ic_igual.svg"
                alt="sinal de igual"
                width="40"
                height="40"
              />
            </div>
            <div className="o-que-e-card-resultado">
              <img
                src="assets/emprestimo-garantia-carro/ic_bank_credit.svg"
                alt="ícone resultado"
              />
              <p className="o-que-e-card-texto">
                Valor de até 100% do
                <br /> veículo em até 24h úteis
              </p>
            </div>
          </div>
          <RedButton
            href="https://emprestimosim.com.br/app/#/onboarding/signUp"
            target="_blank"
            className="btn-o-que-e-simular"
          >
            Simular agora
          </RedButton>
        </ContainerHome24>
        {typeof window === 'undefined' ? (
          <></>
        ) : (
          <>
            {width <= 992 && (
              <picture>
                <source
                  type="image/webp"
                  srcSet="assets/emprestimo-garantia-carro/o-que-e-car.webp"
                />
                <source
                  type="image/png"
                  srcSet="assets/emprestimo-garantia-carro/o-que-e-car.png"
                />
                <img
                  src="assets/emprestimo-garantia-carro/o-que-e-car.png"
                  alt=""
                  className="o-que-e-car"
                  width="320"
                  height="249"
                />
              </picture>
            )}
            {width > 992 && (
              <picture>
                <source
                  type="image/webp"
                  srcSet="assets/emprestimo-garantia-carro/o-que-e-car-desk.webp"
                />
                <source
                  type="image/png"
                  srcSet="assets/emprestimo-garantia-carro/o-que-e-car-desk.png"
                />
                <img
                  src="assets/emprestimo-garantia-carro/o-que-e-car-desk.png"
                  alt=""
                  className="o-que-e-car"
                  width="534"
                  height="393"
                />
              </picture>
            )}
          </>
        )}
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default EmprestimoGarantiaCarroOQueE;
